/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { INutritionPlan } from 'app/shared/model/nutrition-plan.model';

export interface IPatientNutritionPlan {
  id?: string;
  startDate?: number;
  endDate?: number | null;
  microSec?: number;
  timestampentry?: number;
  lastupdated?: number;
  cursor?: number;
  active?: boolean | null;
  glucoUser?: IGlucoUser | null;
  nutritionPlan?: INutritionPlan | null;
}

export const defaultValue: Readonly<IPatientNutritionPlan> = {
  active: false,
};
